/**
 * VendorCard Component
 * Individual vendor card with rank badge and hover animations
 * @component
 */

import React from 'react';
import { VendorCardProps } from '../types';

export const VendorCard: React.FC<VendorCardProps> = ({ vendor, onClick }) => {
  return (
    <div
      className="vendor-card bg-gray-800 rounded-xl shadow-lg overflow-hidden cursor-pointer transition-all duration-300 hover:shadow-green-500/20 hover:-translate-y-2"
      onClick={() => onClick(vendor)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          onClick(vendor);
        }
      }}
      aria-label={`View details for ${vendor.name}, ranked #${vendor.rank}`}
    >
      <div className="p-6">
        <div className="flex justify-between items-start">
          <h3 className="text-xl font-bold text-white pr-4">{vendor.name}</h3>
          <div className="flex-shrink-0 bg-green-600 text-white text-sm font-bold w-12 h-12 rounded-full flex items-center justify-center border-4 border-gray-800 -mt-2 -mr-2">
            #{vendor.rank}
          </div>
        </div>
        <p className="mt-2 text-gray-400 text-sm leading-relaxed h-20 overflow-hidden">
          {vendor.summary}
        </p>
        <div className="mt-4 flex justify-between items-center">
          <div className="text-lg font-bold text-green-400">
            {vendor.score.toFixed(2)}/10
          </div>
          <div className="text-xs font-semibold bg-gray-700 text-gray-300 px-3 py-1 rounded-full">
            Overall Score
          </div>
        </div>
      </div>
    </div>
  );
};
